var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styles.alert_message_parent},[_c('div',{class:[_vm.type === 'default' ? _vm.styles.alert : _vm.styles.alert_error]},[_c('div',{staticClass:"w-full text-center",class:{'flex justify-center md:text-lg': _vm.type === 'default'}},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }